import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coupon-management-settings',
  templateUrl: './coupon-management-settings.component.html',
  styleUrls: ['./coupon-management-settings.component.scss']
})
export class CouponManagementSettingsComponent implements OnInit {

  data: any;
  constructor() { }

  ngOnInit() {
    this.data = {
      'sourcetype': 'entity',
      'partner': 'services',
      'account': 'services',
      'version': 'v1',
      'entity': 'couponmanager'
    };
  }

}
